var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button button-mobile d-flex ai-center jc-center",on:{"click":_vm.goBuyKeyPal}},[_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.$t('home.shopNow')))]),_c('div',{staticClass:"img-wrap d-flex ai-center jc-center",class:{ security: _vm.security }},[_c('div',{staticClass:"img-bg"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }